<template>
    <card style="align-content: center;">
        <Button type="primary" @click="black()">
            <Icon type="chevron-left"></Icon>
            返回
        </Button>
        <div class="k">
            <div v-if="dataList.length > 0">
                <div style="color: red;font-size: 24px;width: 100%;display: flex;justify-content: center;align-items: center">
                    {{ dataList[this.pages - 1][0].question }}
                </div>
                <br>
                <div v-for="(item, index) in dataList[this.pages - 1]" :key="index">
                    <Button v-if="judgeChoose1(item.id_)" type="warning" class="news-content"
                            @click="saveSelevted(item)">
                        {{ item.answer }}
                    </Button>
                    <Button v-if="judgeChoose2(item.id_)" class="news-content" @click="saveSelevted(item)">
                        {{ item.answer }}
                    </Button>
                    <div></div>
                    <br>
                </div>
            </div>
        </div>
        <div v-if="dataList.length > 0">
            <Button style="float: left" type="success" @click="firstPages()">第一页</Button>
            <Button style="float: right" type="success" v-if="this.pages < this.count" @click="nextPages()">下一页</Button>
            <Button style="float: right" type="success" v-if="this.pages >= this.count" @click="submitData()">提交</Button>
        </div>
    </card>
</template>

<script>
    export default {
        data() {
            return {
                dataList: [],
                selectedList: JSON.parse(localStorage.getItem("selectedList")),
                count: 1,
                pages: 1,
            };
        },
        created() {
            this.getBodyPartsList();
        }, methods: {
            getBodyPartsList() {
                this.abHttpUtil
                    .post("/form/formCustSql/view/list_BodySymptomsInterface", {
                        curPage: 1,
                        pageSize: 100,
                        params: {
                            queryData: [{
                                name: "body_parts_class.body_parts_symptoms_id",
                                con: "=",
                                val: this.$route.query.id_
                            }]
                        }
                    })
                    .then(
                        (result) => {
                            let _list = [];
                            this.count = 1;
                            this.dataList = [];
                            for (let i = 0; i < result.data.list.length; i++) {
                                if (this.count !== result.data.list[i].pages) {
                                    this.dataList.push(_list);
                                    _list = [];
                                    this.count += 1;
                                }
                                _list.push({
                                    "id_": result.data.list[i].id_,
                                    "question": result.data.list[i].question,
                                    "answer": result.data.list[i].answer,
                                    "pages": result.data.list[i].pages,
                                });
                                if (i === result.data.list.length - 1) {
                                    this.dataList.push(_list);
                                    _list = [];
                                }
                            }
                        },
                        function (status) {
                            if (status == !0) {
                                this.$Message.error("加载失败！" + status);
                            }
                        }
                    );
            },
            saveSelevted(item) {
                if (this.selectedList === 0) {
                    this.selectedList = []
                }
                if (this.selectedList.indexOf(item.id_) === -1) {
                    this.selectedList.push(item.id_);
                    localStorage.setItem("selectedList", JSON.stringify(this.selectedList))
                } else {
                    let that = this;
                    this.selectedList.forEach(function(s,i,a){
                            if(item.id_ === s){
                                that.selectedList.splice(i,1)
                            }
                    });
                    localStorage.setItem("selectedList", JSON.stringify(this.selectedList))
                }
            },
            judgeChoose1(id_) {
                if (this.selectedList.length > 0) {
                    if (this.selectedList.indexOf(id_) === -1) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            judgeChoose2(id_) {
                if (this.selectedList.length > 0) {
                    if (this.selectedList.indexOf(id_) === -1) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return true
                }
            },
            black() {
                this.$router.push({
                    path: "/BodySymptoms",
                    query: {id_: this.$route.query.bid_},
                });
            },
            firstPages() {
                this.getBodyPartsList();
                this.pages = 1;
            },
            nextPages() {
                this.getBodyPartsList();
                this.pages += 1;
            },
            submitData() {
                if (this.selectedList !== 0 && this.selectedList.length > 1) {
                    this.$router.push({
                        path: "/SymptomsDescribedCalculate",
                        query: {
                            name: this.$route.query.name,
                        },
                    });
                }
            }
        },
    }
</script>

<style scoped>
    .news-content {
        font-size: 24px;
        /*background-color: white;*/
        color: black;
        width: 100%;
        border: 2px solid;
        border-color: #0a80ff;
    }

    .k {
       /* !*打开布局*!*/
       /* display: flex;*/
       /*!*水平居中*!*/
       /* justify-content: center;*/
       /* !*垂直居中*!*/
        align-items: center;
    }
</style>
